import { jsx, jsxs } from 'react/jsx-runtime';
import { isScrollable, canScrollTo } from '@flex-design-system/fx-utils/element';
import { useSize, useResizeObserver } from '@flex-design-system/fx-utils/hooks';
import { composeEventHandlers } from '@radix-ui/primitive';
import { useComposedRefs } from '@radix-ui/react-compose-refs';
import { Primitive } from '@radix-ui/react-primitive';
import { assignInlineVars } from '@vanilla-extract/dynamic';
import classNames from 'classnames';
import { forwardRef, useState, useRef, useCallback } from 'react';
import { ScrollArea } from '../../../scroll-area/ScrollArea.mjs';
import { useModalContext } from '../../context.mjs';
import { FOG_HEIGHT } from '../../styles.vanilla.mjs';
import { ModalFog } from '../fog/Fog.mjs';
import { scrollAreaRootLegacy, childrenRootLegacy, scrollAreaViewportLegacyPaddingBottom, scrollAreaViewportLegacyPaddingTop, scrollAreaViewportLegacy, scrollbarMarginTop } from './scrollAreaLegacy.vanilla.mjs';
import { StyledScrollAreaViewport_Legacy } from './styled.mjs';

const ModalScrollArea = forwardRef((props, ref) => {
  const {
    children,
    css,
    className,
    toolbar,
    onScroll,
    toolbarHeightFallback = 0,
    style: styleFromProps,
    ...bodyProps
  } = props;
  const [viewportElement, setViewportElement] = useState(
    null
  );
  const childrenRef = useRef(null);
  const {
    setScrollPos,
    toolbar: toolbarElement,
    onContentElementChange
  } = useModalContext("Modal.ScrollArea_Legacy");
  const childrenComposedRef = useComposedRefs(
    childrenRef,
    onContentElementChange
  );
  const scrollable = isScrollable(viewportElement);
  const needScrollFog = canScrollTo(viewportElement, "bottom");
  const toolbarSize = useSize(toolbarElement ?? null);
  const toolbarElementHeight = toolbarSize?.height ?? 0;
  const toolbarHeight = toolbarElementHeight > 0 ? toolbarElementHeight : toolbarHeightFallback;
  const handleScroll = useCallback(() => {
    setScrollPos(viewportElement?.scrollTop ?? 0);
  }, [setScrollPos, viewportElement?.scrollTop]);
  useResizeObserver(childrenRef.current, handleScroll);
  return /* @__PURE__ */ jsx(
    Primitive.div,
    {
      ref,
      className: scrollAreaRootLegacy,
      style: assignInlineVars({ [scrollbarMarginTop]: `${toolbarHeight}px` }),
      ...bodyProps,
      children: /* @__PURE__ */ jsxs(ScrollArea, { children: [
        /* @__PURE__ */ jsxs(
          StyledScrollAreaViewport_Legacy,
          {
            css,
            className: classNames(scrollAreaViewportLegacy, className),
            style: Object.assign(
              {},
              assignInlineVars({
                [scrollAreaViewportLegacyPaddingTop]: `${toolbarHeight}px`,
                [scrollAreaViewportLegacyPaddingBottom]: `${scrollable ? FOG_HEIGHT : 64}px`
              }),
              styleFromProps
            ),
            ref: setViewportElement,
            onScroll: composeEventHandlers(onScroll, handleScroll),
            children: [
              toolbar,
              /* @__PURE__ */ jsx("div", { ref: childrenComposedRef, className: childrenRootLegacy, children })
            ]
          }
        ),
        needScrollFog && /* @__PURE__ */ jsx(ModalFog, { side: "bottom", color: "#FFFFFF" })
      ] })
    }
  );
});

export { ModalScrollArea as ModalScrollArea_Legacy };
//# sourceMappingURL=ScrollArea_Legacy.mjs.map
